export default "__VITE_ASSET__C_I3N9wu__"